import { Box, Typography } from '@mui/material';

interface Props {
  total: string;
}

const MonthlySummaryBox = ({ total }: Props) => (
  <Box className="summary-container">
    <Box className="summary-row">
      <Typography className="summary-label">Total</Typography>
      <Typography className="summary-value">{total}</Typography>
    </Box>
  </Box>
);

export default MonthlySummaryBox;
